import React from 'react'
import reactStamp from 'react-stamp'
import './home.css'

export default reactStamp(React).compose({

    render() {
        if (this.props.practitioner.name != undefined) {
            let name =
                this.props.practitioner.name.prefix || ""+" "+
                this.props.practitioner.name.family+" "+
                this.props.practitioner.name.given+" "+
                this.props.practitioner.name.suffix || ""
            
            return (
                <div className="card-container">
                    <h2 className="primary-card-name-label">Primary Care Physician</h2>
                    <p className="card-info-label">
                        {name}
                    </p>
                    <p className="card-info-label">{this.props.practitioner.email}</p>
                </div>
            )
        } else {
            return null;
        }
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/components/Home/PrimaryCareCard.js
 **/